import { Redirect, Route, type RouteComponentProps, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app'
import { useAppRoutes } from '@webapp/hooks'
import { Permissions } from '@webapp/platform/iam'
import {
  UnbilledExpenseItemsPageStatuses,
  UnbilledItemsPageStatuses,
} from './types'
import { UnbilledExpenseItemsPage } from './UnbilledExpenseItemsPage'
import { UnbilledItemsPage } from './UnbilledItemsPage'

const UNBILLED_PAGE_PERMISSIONS = [
  Permissions.ACCOUNTS_PAYABLE_ADD_BILL,
  Permissions.ACCOUNTS_PAYABLE_VIEW_BILL,
  Permissions.ACCOUNTS_PAYABLE_EDIT_DRAFT_PENDING_DENIED_BILLS,
  Permissions.ACCOUNTS_PAYABLE_EDIT_APPROVED_BILLS,
  Permissions.ACCOUNTS_PAYABLE_DELETE_SUBMITTED_BILLS,
]

const isUnbilledItemsPageStatus = (status: string | undefined) =>
  (Object.values(UnbilledItemsPageStatuses) as string[]).includes(status ?? '')

const isUnbilledExpenseItemsPageStatus = (status: string | undefined) =>
  (Object.values(UnbilledExpenseItemsPageStatuses) as string[]).includes(
    status ?? ''
  )

export const UnbilledItemPageRouter = () => {
  const { brp, url } = useAppRoutes()

  return (
    <Switch>
      <ProtectedRoute
        path={brp('UnbilledItemsPage', { status: ':status?' })}
        customFilter={({ featureSwitches, permissions }) =>
          // The Angular `ap` parent state redirects to `/` when AP navigation
          // is disabled — mirror that guard here.
          !featureSwitches.disable_ap_navigation &&
          UNBILLED_PAGE_PERMISSIONS.some((permission) =>
            permissions.includes(permission)
          )
        }
        render={({ match }: RouteComponentProps<{ status?: string }>) =>
          isUnbilledItemsPageStatus(match.params.status) ? (
            <UnbilledItemsPage />
          ) : (
            <Redirect
              to={url('UnbilledItemsPage', {
                status: UnbilledItemsPageStatuses.ACTIVE,
              })}
            />
          )
        }
      />

      <ProtectedRoute
        path={brp('UnbilledExpenseItemsPage', { status: ':status?' })}
        customFilter={({ featureSwitches, permissions }) =>
          // The Angular `ap` parent state redirects to `/` when AP navigation
          // is disabled — mirror that guard here.
          !featureSwitches.disable_ap_navigation &&
          UNBILLED_PAGE_PERMISSIONS.some((permission) =>
            permissions.includes(permission)
          )
        }
        render={({ match }: RouteComponentProps<{ status?: string }>) =>
          isUnbilledExpenseItemsPageStatus(match.params.status) ? (
            <UnbilledExpenseItemsPage />
          ) : (
            <Redirect
              to={url('UnbilledExpenseItemsPage', {
                status: UnbilledExpenseItemsPageStatuses.PENDING,
              })}
            />
          )
        }
      />

      <Route
        path='*'
        render={() => (
          <Redirect
            to={url('UnbilledItemsPage', {
              status: UnbilledItemsPageStatuses.ACTIVE,
            })}
          />
        )}
      />
    </Switch>
  )
}
